import React from 'react';
const features = [
  {
    title: 'Saved Expenses',
    desc: 'Track your spending in local currency and see it automatically converted to your home currency.',
    iconClass: 'icon-wallet',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-[#6750A4]">
        <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
      </svg>
    ),
  },
  {
    title: 'Split Expenses',
    desc: "Split converted costs between friends and see each person's share before saving the expense.",
    iconClass: 'icon-split',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-[#6750A4]">
        <path d="M16 21v-2a4 4 0 0 0-8 0v2"/>
        <circle cx="12" cy="7" r="4"/>
        <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    title: 'Works Offline',
    desc: 'AwayFX caches the latest rates locally. Convert prices even in the middle of the desert. No data plan needed.',
    iconClass: 'icon-wifi',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-[#6750A4]">
        <line x1="1" y1="1" x2="23" y2="23"/>
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/>
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/>
        <path d="M10.71 5.05A16 16 0 0 1 22.56 9"/>
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/>
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
        <line x1="12" y1="20" x2="12.01" y2="20"/>
      </svg>
    ),
  },
  {
    title: 'Home Screen Widget',
    desc: 'Check your favourite currency pairs right from your home screen with a beautiful Material You dynamic widget.',
    iconClass: 'icon-widget',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-[#6750A4]">
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
  },
];
export function FeaturesSection() {
  return (
    <section className="bg-white dark:bg-zinc-950 py-24">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="mb-16">
          <div className="text-xs font-bold tracking-[0.12em] uppercase text-[#6750A4] mb-3">What&apos;s inside</div>
          <h2 className="text-[clamp(32px,3.5vw,48px)] font-extrabold tracking-[-0.03em] leading-[1.1] text-[#1D1B20] dark:text-white mb-4">
            Built for real travel.
          </h2>
          <p className="text-lg text-[#79747E] leading-relaxed max-w-[500px]">
            Everything you need when crossing borders, nothing you don&apos;t.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="feature-card rounded-3xl p-9 border border-[#E7E0EC] dark:border-zinc-800 bg-[#FEF7FF] dark:bg-[#1C1B1F] transition-all duration-300 hover:-translate-y-1"
              onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 16px 48px -8px rgba(103,80,164,0.15)')}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = 'none')}
            >
              <div className={`w-[52px] h-[52px] rounded-2xl flex items-center justify-center mb-6 ${f.iconClass}`}
                style={{ background: '#EADDFF' }}>
                {f.icon}
              </div>
              <div className="text-xl font-bold tracking-[-0.02em] text-[#1D1B20] dark:text-white mb-2.5">{f.title}</div>
              <p className="text-base text-[#79747E] leading-[1.65]">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
